/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from "axios";
import { erpAxios, getAuthToken } from "../axiosInstances";

export class UserWarehouseApi {
  public static api = new UserWarehouseApi();
  private instance = erpAxios;

  getToken() {
    return getAuthToken();
  }

  async getUserWarehouses(
    userId: number,
    page: number,
    pageSize: number,
    search: string = ""
  ): Promise<any> {
    try {
      const response: AxiosResponse<any> = await this.instance.get(
        `/erp/api/v1/users/warehouse`,
        {
          params: { userId, page, pageSize, search },
          headers: { Authorization: `Bearer ${this.getToken()}` },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching user warehouses", error);
      throw error;
    }
  }

  async assignWarehouse(
    userId: number,
    warehouseId: number,
    assign: boolean
  ): Promise<any> {
    try {
      const body = { userId, warehouseId, assign };
      const response: AxiosResponse<any> = await this.instance.put(
        `/erp/api/v1/users/warehouse/assign`,
        body,
        {
          headers: { Authorization: `Bearer ${this.getToken()}` },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error assigning/unassigning warehouse", error);
      throw error;
    }
  }

  async getUserList(role: string | undefined, roleId: number | undefined, page: number, size: number): Promise<any> {
    try {
      const response: AxiosResponse<any> = await this.instance.get(`/erp/api/user/list`, {
        params: { role, roleId, page, size },
        headers: { Authorization: `Bearer ${this.getToken()}` },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching user list", error);
      throw error;
    }
  }

  async getAssignedWarehouses(): Promise<any> {
    try {
      const response: AxiosResponse<any> = await this.instance.get(
        `/erp/api/v1/users/warehouse/assigned`,
        {
          headers: { Authorization: `Bearer ${this.getToken()}` },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching assigned warehouses", error);
      throw error;
    }
  }

  async setDefaultWarehouse(warehouseId: number): Promise<any> {
    try {
      const response: AxiosResponse<any> = await this.instance.put(
        `/erp/api/v1/users/warehouse`,
        null,
        {
          params: { defaultWarehouseId: warehouseId },
          headers: { Authorization: `Bearer ${this.getToken()}` },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error setting default warehouse", error);
      throw error;
    }
  }
}

export default UserWarehouseApi;
